import { AppBar, Container, Dialog, DialogContent, IconButton, Toolbar, Typography } from "@mui/material";
import { Slide } from "@mui/material";
import { TransitionProps } from "@mui/material/transitions";
import React from "react";
import CloseIcon from '@mui/icons-material/Close';
import { DialogProps } from "../../types/externas/mui-type";

export default function DialogFullScreen({
    open,
    handleClose,
    title,
    children,
    actionButton
}: DialogFullScreenProps) {
    return (
        <Dialog
            fullScreen
            open={open}
            onClose={handleClose}
            TransitionComponent={Transition}
        >
            <AppBar sx={{ position: 'relative' }} elevation={1}>
                <Container>
                    <Toolbar>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleClose}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>

                        <Typography
                            variant="h6"
                            component="div"
                            sx={{ ml: 2, flex: 1 }}
                        >
                            {title}
                        </Typography>

                        {actionButton}
                    </Toolbar>
                </Container>
            </AppBar>

            <DialogContent sx={{ bgcolor: "#f0f0f0" }}>
                <Container sx={{ pt: 1 }}>
                    {children}
                </Container>
            </DialogContent>
        </Dialog>
    )
}

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

interface DialogFullScreenProps extends DialogProps {
    title: string;
    children: React.ReactNode;
    actionButton?: React.ReactNode;
}